import axios from 'axios';
import { setInterceptor } from './authService'
import Config from "../Config"


export  const getAuthAPI = () => {
  const apiInstance = axios.create({
    baseURL: Config.apiPath
  })
  return setInterceptor(apiInstance);
}
